import React, {useCallback, useEffect} from 'react';
import {useForm} from "react-hook-form";
import apiClient from "../../../utils/apiClient";
import FormSubmitButton from "../../forms/form-control/FormSubmitButton";
import {updateStateValue} from "../../../utils/stateHelpers";
import {isEmpty} from "lodash";
import FormInputDate from "../../forms/form-control/FormInputDate";
import moment from "moment";

/**
 * Filter component for business development dashboard
 * @returns {JSX.Element}
 * @constructor
 */
const BusinessDevelopmentDashboardFilters = (prop) => {
    const {register, handleSubmit, errors, setValue, getValues} = useForm();
    const {setData, setReportFilters, onExportClick} = prop;

    // submit handler for report filter
    const onSubmit = useCallback((data) => {
      console.log('first')
        updateStateValue(setReportFilters, 'isLoading', true);
        updateStateValue(setReportFilters, 'isSubmitted', true);

        apiClient
            .get('getBusinessDevelopmentDashboardData', {params: data})
            .then(response => {
                if (isEmpty(response.data)) {
                  setData([]);
                    return;
                }
                console.log(data)
                setData(response.data);
                updateStateValue(setReportFilters, 'isLoading', false);
                updateStateValue(setReportFilters, 'dateFrom', data.date_from);
                updateStateValue(setReportFilters, 'dateTo', data.date_to);
            })
    }, [setData, setReportFilters]);

    // get list of daily dates
    useEffect(() => {
        setValue('date_from', moment().startOf("year").format("YYYY-MM-DD"));
        setValue('date_to', moment().endOf("year").format("YYYY-MM-DD"));
        handleSubmit(onSubmit)();
        // set yesterday date for date range components
    }, [handleSubmit, onSubmit, setValue]);

    return (
        <form
            className="needs-validation container-fluid mb-2"
            onSubmit={handleSubmit(onSubmit)}
        >
            <div className="form-row">
                <FormInputDate
                    id="date_from"
                    label="From"
                    className="col-md-2"
                    onChange={() => {
                        if (isEmpty(getValues('date_to'))) {
                            setValue('date_to', getValues('date_from'));
                        }

                    }}
                    register={register({required: "required"})}
                    errors={errors}
                />
                <FormInputDate
                    id="date_to"
                    label="To"
                    className="col-md-2"
                    register={register({required: "required"})}
                    errors={errors}
                />
                <div className="form-row">
                  <FormSubmitButton
                      label="Show"
                      className="ml-2"
                  />
                  <FormSubmitButton 
                    type="button" 
                    className="ml-2" 
                    onClick={onExportClick} 
                    label="Export to PDF" 
                  />
                </div>
                
            </div>
        </form>
    );
}

export default BusinessDevelopmentDashboardFilters;
